import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyle from 'shared/hooks/useStyle'
import styles from './IATAScanSummary.style'

const propTypes = {
    value: PropTypes.string,
    isAnswered: PropTypes.bool,
    onRetry: PropTypes.func,
}

const IATAScanSummary = ({
    isAnswered = false,
    value = '',
    onRetry,
}) => {
    const { t } = useTranslation()
    const classes = useStyle(styles)

    return (
        <div css={classes.root}>
            { !isAnswered && t('NO_SCAN_PERFORMED') }
            { isAnswered && t('CORRECT_STICKER', { tempRange: value }) }
            { onRetry && (
                <div css={classes.actions}>
                    <Button
                        data-testid="retry-button"
                        css={classes.button}
                        onClick={onRetry}
                    >
                        {t('RETRY')}
                    </Button>
                </div>
            )}
        </div>
    )
}

IATAScanSummary.propTypes = propTypes

export default IATAScanSummary
